export default {
    SET_LOADING_STATE: "reviewDocuments/SET_LOADING_STATE",
    SET_DIALOG_STATE: "reviewDocuments/SET_DIALOG_STATE",
    GET_DOCUMENTS: "reviewDocuments/GET_DOCUMENTS",
    SET_IS_ACCEPTED: "reviewDocuments/SET_IS_ACCEPTED",
};